import { ref } from 'vue';

export default defineNuxtPlugin(() => {
  const logoText = ref('Dashboard')

  return {
    provide: {
      logoText
    }
  }
})
